// SEG-A2 FRONT-A2: bucket 'signatures' privado — gravação na pasta da empresa
// ({company_id}/{dono}/arquivo) e exibição por link temporário (createSignedUrl).
// O formato gravado no banco NÃO muda: deliveries.signature_url etc. seguem com o
// endereço devolvido por getPublicUrl(path); a exibição converte na hora.
import { supabase } from '@/integrations/supabase/client';

export const SIGNATURES_BUCKET = 'signatures';

/** Caminho novo: {company_id}/{dono}/arquivo (regra do banco aceita também o legado {dono}/arquivo). */
export function buildSignaturePath(companyId: string, ownerId: string, fileName: string): string {
  return `${companyId}/${ownerId}/${fileName}`;
}

/**
 * Extrai o caminho dentro do bucket a partir do valor gravado:
 * - vazio/nulo => null
 * - URL pública (contém '/signatures/') => trecho após a ÚLTIMA ocorrência, sem query string, decodificado
 * - não começa com http => já é caminho (devolve como está)
 * - outra URL => null
 */
export function signaturePathFromValue(value?: string | null): string | null {
  if (!value) return null;
  const marker = '/signatures/';
  const idx = value.lastIndexOf(marker);
  if (idx >= 0) {
    const raw = value.slice(idx + marker.length).split('?')[0];
    if (!raw) return null;
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
  if (!/^https?:\/\//i.test(value)) return value;
  return null;
}

/** Link temporário para exibir o arquivo do bucket privado. Erro => console.warn e null. */
export async function getSignatureSignedUrl(value?: string | null, expiresIn = 3600): Promise<string | null> {
  const path = signaturePathFromValue(value);
  if (!path) return null;
  const { data, error } = await supabase.storage.from(SIGNATURES_BUCKET).createSignedUrl(path, expiresIn);
  if (error || !data?.signedUrl) {
    console.warn('Erro ao gerar link temporário da assinatura:', error ?? 'sem signedUrl', path);
    return null;
  }
  return data.signedUrl;
}
